import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { Spinner } from '../components/ui/Spinner';
import { isAdminOrAbove } from '../lib/roles';

// Blocks unauthenticated users. adminOnly blocks resellers. A session that hasn't
// passed the emailed 2FA code yet is sent back to /login (the code screen).
export function ProtectedRoute({ children, adminOnly = false }) {
  const { session, profile, loading, mfaRequired } = useAuth();

  if (loading) return <Spinner label="Checking session…" />;
  if (!session) return <Navigate to="/login" replace />;
  if (mfaRequired) return <Navigate to="/login" replace />;
  if (adminOnly && profile && !isAdminOrAbove(profile)) return <Navigate to="/" replace />;

  return children;
}
